import { postsDB } from '../../firestoreDB'
import {
  GET_NEXT_TAGS,
  REFRESH_TAGS_PUBLISHED_AT,
  GET_TAG_DATA_FROM_REFERENCE,
  UPDATE_TAGS_PUBLISHED_AT,
  ADD_TAG_REF,
  UPDATE_TAG_REF,
  DELETE_TAG,
  SET_TAG_DATA,
  UPDATE_TAGS_DATES,
  RESET_TAGS_ACTION,
  MERGE_TAG,
  MERGE_TAG_POST_DATA,
  RESET_TAGS
} from '../actions/tagsQueries'
import { _ } from 'vue-underscore'
import firebase from 'firebase'
import {addListItem, getIndexForNewItem, getIndexForItem} from '@/helper/helper'
import {docToPostData, docToPostRef} from '@/converters/postConverter'
import {getUserTagNamesRefsPage} from '@/helper/paginate'
const getDefaultState = () => ({
  tagRefs: [],
  tagData: [],
  lastAuthorPublishedAt: new Date().getTime() / 1000
})

const state = getDefaultState()

const getters = {

  getTagPostsData: state => _.compact(state.tagData),
  getTagPostsRefs: state => state.tagRefs,
  getLastTagPostsPublishedAt: state => state.lastAuthorPublishedAt
}

const actions = {
  [GET_NEXT_TAGS]: ({ getters, dispatch, commit }, tagName) => {
    return new Promise((resolve) => {
      const last = _.last(getters.getTagPostsRefs)
      const source = getUserTagNamesRefsPage(last && last.score, tagName)
      source.onSnapshot({ includeMetadataChanges: true }, snapshot => {
        snapshot.docChanges().forEach(docChanged => {
          const doc = docChanged.doc
          let tagPostRef = null
          switch (docChanged.type) {
            case 'added':
              tagPostRef = docToPostRef(doc)
              commit(ADD_TAG_REF, tagPostRef)
              dispatch(GET_TAG_DATA_FROM_REFERENCE, tagPostRef)
              break
            case 'modified':
              tagPostRef = docToPostRef(doc)
              commit(UPDATE_TAG_REF, tagPostRef)
              break
            case 'removed':
              commit(DELETE_TAG, doc.id)
              commit(DELETE_TAG, doc.id)
              break
            default:
              break
          }
        })
        resolve(true)
      })
    })
  },
  [GET_TAG_DATA_FROM_REFERENCE]: ({ commit, dispatch, getters }, item) => {
    postsDB
      .where(firebase.firestore.FieldPath.documentId(), '==', item.docId)
      .onSnapshot({ includeMetadataChanges: true }, snapshotDoc => {
        snapshotDoc.docChanges().forEach(docChanged => {
          const doc = docChanged.doc
          const postData = docToPostData(doc, item)
          switch (docChanged.type) {
            case 'added':
              commit(SET_TAG_DATA, postData)
              dispatch(UPDATE_TAGS_DATES)
              break
            case 'modified':
              commit(SET_TAG_DATA, postData)
              dispatch(UPDATE_TAGS_DATES)
              break
            case 'removed':
              break
            default:
              break
          }
        })
      })
  },
  [UPDATE_TAGS_DATES]: ({ commit, getters }) => {
    const twoDaysInSeconds = 172800
    const minute = 60
    const todaySeconds = new Date().getTime() / 1000 // today seconds
    if (todaySeconds - getters.getLastTagPostsPublishedAt > minute) {
      getters.getTagPostsData.map((item, index) => {
        if (item) {
          let seconds = item.published_at.seconds
          const diff = todaySeconds - seconds
          if (diff <= twoDaysInSeconds) {
            commit(REFRESH_TAGS_PUBLISHED_AT, { item, index })
          } else return true
        }
      })
      commit(UPDATE_TAGS_PUBLISHED_AT, todaySeconds)
    }
  },
  [RESET_TAGS_ACTION]: ({ commit }) => {
    commit(RESET_TAGS)
  },
  [MERGE_TAG]: ({ commit }, value) => {
    commit(MERGE_TAG_POST_DATA, value)
  }
}

const mutations = {
  [ADD_TAG_REF]: (state, elemRef) => {
    const newIndexRef = getIndexForNewItem(state.tagRefs, 'score', elemRef.score)
    state.tagRefs.splice(newIndexRef, 0, elemRef)
    state.tagData.splice(newIndexRef, 0, null)
  },
  [UPDATE_TAG_REF]: (state, elemRef) => {
    const oldIndexRef = getIndexForItem(state.tagRefs, 'key', elemRef.key)
    const oldElemeRef = state.tagRefs[oldIndexRef]
    let elemData = null
    let newIndexRef = -1
    let hasIndexChanged = oldElemeRef.score !== elemRef.score
    if (hasIndexChanged) {
      newIndexRef = getIndexForNewItem(state.tagRefs, 'score', elemRef.score)
      hasIndexChanged = newIndexRef !== oldIndexRef
    }
    if (hasIndexChanged) {
      state.tagRefs.splice(oldIndexRef, 1)
      let elemDataList = state.tagData.splice(oldIndexRef, 1)
      elemData = elemDataList[0] || null
      newIndexRef = newIndexRef > oldIndexRef ? newIndexRef - 1 : newIndexRef // Testear
      state.tagRefs = addListItem([...state.tagRefs], elemRef, newIndexRef)
      elemData = elemData ? {...elemData, ...elemRef} : elemData
      state.tagData = addListItem([...state.tagData], elemData, newIndexRef)
    } else {
      state.tagRefs[oldIndexRef] = elemRef
      let tagData = state.tagData
      elemData = tagData[oldIndexRef]
      elemData = elemData ? {...elemData, ...elemRef} : elemData
      tagData[oldIndexRef] = elemData
      state.tagData = [...tagData]
    }
  },
  [SET_TAG_DATA]: (state, elemData) => {
    const index = getIndexForItem(state.tagRefs, 'key', elemData.key)
    if (index > -1) {
      let tagData = [...state.tagData]
      tagData[index] = elemData
      state.tagData = tagData
    }
  },
  [MERGE_TAG_POST_DATA]: (state, value) => {
    const { key, data } = value
    let postElement = _.findWhere(state.tagData, { key: key })
    if (_.size(postElement) > 0) {
      postElement.like = data.like
      state.tagData[postElement.index] = postElement
    }
  },
  [REFRESH_TAGS_PUBLISHED_AT]: (state, { item, index }) => {
    state.tagData[index] = {...state.tagData[index],
      published_at: item.published_at,
      moment: Math.random()
    }
  },
  [UPDATE_TAGS_PUBLISHED_AT]: (state, dateTimeSeconds) => {
    state.lastFavPublishedAt = dateTimeSeconds
  },
  [DELETE_TAG]: (state, key) => {
    const postIndex = getIndexForItem(state.tagRefs, 'key', key)
    if (postIndex > -1) {
      state.tagRefs.splice(postIndex, 1)
      state.tagData.splice(postIndex, 1)
    }
  },
  [RESET_TAGS]: state => {
    Object.assign(state, getDefaultState())
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/tagsQuery.js